import { HedepyPlusIcon } from '@hedepy/icons/refactor/HedepyPlus'

import { getTranslate } from '@/legacy-src/utilities/i18n'

import { Text } from '@/src/domains/design-system/components/Text'

export interface ClientBookingSubscriptionStatusMessageProps {
  month: string
  freeEventsLeft: number
}

export const ClientBookingSubscriptionStatusMessage = ({
  month,
  freeEventsLeft,
}: ClientBookingSubscriptionStatusMessageProps) => {
  const { t } = getTranslate()

  return (
    <div className="mb-6 flex items-center gap-2 rounded-xl bg-blue-500 p-3 tablet:justify-center">
      <div className="p-1.5">
        <HedepyPlusIcon size={24} className="shrink-0 text-white-500" />
      </div>
      <div className="flex flex-wrap gap-x-3">
        <Text element="span" variant="sm">
          {t('component.benefits.sessionsLeftInMonth', { month })}
        </Text>
        <Text element="span" variant="sm" weight="bold">
          {t('component.subscription.prepaidSessionsPlural', { count: freeEventsLeft })}
        </Text>
      </div>
    </div>
  )
}
